/* TUNNEL MONO-PRODUIT — Claude, 2026-10-20.
   Bloc d'achat : coloris, taille, offre 1 ou 2 pièces, total en direct, puis envoi au
   paiement par lien panier (/cart/ID:QTE,ID:QTE), sans page panier intermédiaire. */
(function () {
  'use strict';

  // `modele` = 1234567 passé au filtre `money` de Shopify (devise de présentation) :
  // on y lit symbole et séparateurs, puis on y remplace le nombre.
  function formaterModele(centimes, modele) {
    var m = typeof modele === 'string' ? modele.match(/12([^\d]?)345([^\d])67/) : null;
    if (!m) return null;
    var parts = (centimes / 100).toFixed(2).split('.');
    var ent = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, m[1]);
    return modele.replace(m[0], ent + m[2] + parts[1]);
  }

  function formater(centimes, format, modele) {
    var viaModele = formaterModele(centimes, modele);
    if (viaModele) return viaModele;
    var euros = (centimes / 100).toFixed(2);
    var virgule = euros.replace('.', ',');
    var sansDec = Math.round(centimes / 100).toString();
    return (format || '{{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, virgule)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, sansDec)
      .replace(/\{\{\s*amount\s*\}\}/, euros)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, sansDec);
  }

  // transitions.dev : lecture d'un jeton de durée sur :root.
  function jeton(nom, defaut) {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(nom));
    return isFinite(v) ? v : defaut;
  }

  // transitions.dev, « text swap soft » : l'ancien montant se floute pendant que le
  // nouveau apparaît au même endroit ; la largeur glisse vers la nouvelle.
  function changerTexte(el, suivant) {
    if (!el) return;
    var avant = el.dataset.texte != null ? el.dataset.texte : el.textContent;
    if (avant === suivant) return;
    el.dataset.texte = suivant;
    if (!el.isConnected || !el.getClientRects().length || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = suivant;
      return;
    }
    clearTimeout(el._minuteur);
    el.classList.add('lp-swap');
    var vieux = document.createElement('span');
    vieux.className = 'lp-swap-old';
    vieux.setAttribute('aria-hidden', 'true');
    vieux.textContent = avant;
    var neuf = document.createElement('span');
    neuf.className = 'lp-swap-new';
    neuf.textContent = suivant;
    var l0 = el.getBoundingClientRect().width;
    el.classList.remove('is-swapping');
    el.replaceChildren(vieux, neuf);
    var l1 = neuf.getBoundingClientRect().width;
    el.style.width = l0 + 'px';
    void el.offsetWidth;
    el.classList.add('is-swapping');
    el.style.width = l1 + 'px';
    el._minuteur = setTimeout(function () {
      el.classList.remove('is-swapping', 'lp-swap');
      el.style.removeProperty('width');
      el.textContent = suivant;
    }, Math.max(jeton('--text-soft-dur', 200), jeton('--text-soft-resize-dur', 240)) + 40);
  }

  // transitions.dev, « error state shake » : la rangée de tailles se secoue (280 ms).
  function secouer(el) {
    if (!el) return;
    el.classList.remove('is-shaking');
    void el.offsetWidth;
    el.classList.add('is-shaking');
    var duree = jeton('--shake-dur-a', 80) * 2 + jeton('--shake-dur-b', 60) * 2;
    setTimeout(function () { el.classList.remove('is-shaking'); }, duree + 20);
  }

  function initAchat(racine) {
    var donnees;
    try { donnees = JSON.parse(racine.querySelector('[data-lp-donnees]').textContent); } catch (e) { return; }
    var variantes = donnees.variantes;
    var format = donnees.format;
    var modele = donnees.modele;
    var iC = parseInt(racine.dataset.idxCouleur, 10);
    var iT = parseInt(racine.dataset.idxTaille, 10);
    var remise = parseInt(racine.dataset.remise, 10) || 0;
    var form = racine.querySelector('[data-lp-form]');
    var pieces = [].slice.call(racine.querySelectorAll('[data-lp-piece]'));
    var radiosQte = [].slice.call(racine.querySelectorAll('[data-lp-quantite]'));
    var bouton = racine.querySelector('[data-lp-commander]');
    var total = racine.querySelector('[data-lp-total]');
    var dispo = racine.querySelector('[data-lp-dispo]');
    var idRepli = racine.querySelector('[data-lp-id-repli]');

    function quantite() {
      var r = radiosQte.filter(function (x) { return x.checked; })[0];
      return r ? parseInt(r.value, 10) : 1;
    }
    function valeur(piece, sel) {
      var r = piece.querySelector(sel + ':checked');
      return r ? r.value : null;
    }
    function trouver(couleur, taille) {
      return variantes.filter(function (v) {
        return (iC < 0 || v.options[iC] === couleur) && (iT < 0 || v.options[iT] === taille);
      })[0] || null;
    }
    function premiereDeCouleur(couleur) {
      return variantes.filter(function (v) { return iC < 0 || v.options[iC] === couleur; })[0] || variantes[0];
    }
    function etatPiece(piece) {
      var c = iC >= 0 ? valeur(piece, '[data-lp-couleur]') : null;
      var t = iT >= 0 ? valeur(piece, '[data-lp-taille]') : null;
      var v = (iT < 0 || t) ? trouver(c, t) : null;
      return { couleur: c, taille: t, variante: v, reference: v || premiereDeCouleur(c) };
    }

    function majTailles(piece) {
      if (iT < 0) return;
      var c = iC >= 0 ? valeur(piece, '[data-lp-couleur]') : null;
      piece.querySelectorAll('[data-lp-taille]').forEach(function (inp) {
        var v = trouver(c, inp.value);
        var ok = v && v.dispo;
        inp.disabled = !ok;
        if (!ok && inp.checked) inp.checked = false;
      });
    }

    function montrerMedia(mediaId) {
      if (!mediaId) return;
      var g = racine.querySelector('[data-lp-galerie]');
      if (!g) return;
      g.querySelectorAll('.lp-galerie__img').forEach(function (img) {
        img.classList.toggle('is-on', String(img.dataset.mediaId) === String(mediaId));
      });
      g.querySelectorAll('[data-lp-vignette]').forEach(function (b) {
        var on = String(b.dataset.lpVignette) === String(mediaId);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function maj() {
      var q = quantite();
      pieces.forEach(function (piece, i) {
        piece.hidden = i >= q;
        var lbl = piece.querySelector('[data-lp-valeur-couleur]');
        if (lbl) lbl.textContent = valeur(piece, '[data-lp-couleur]') || '';
      });
      var actives = pieces.slice(0, q).map(etatPiece);
      var prix = actives.map(function (e) { return e.reference.prix; });
      var somme = prix.reduce(function (a, b) { return a + b; }, 0);
      var reduc = q >= 2 ? Math.round(Math.min.apply(null, prix) * remise / 100) : 0;
      changerTexte(total, '· ' + formater(somme - reduc, format, modele));
      changerTexte(document.querySelector('[data-lp-barre-prix]'), formater(somme - reduc, format, modele));

      var p1 = racine.querySelector('[data-lp-prix-1]');
      var p2 = racine.querySelector('[data-lp-prix-2]');
      var p2b = racine.querySelector('[data-lp-prix-2-barre]');
      var ref = actives[0].reference.prix;
      changerTexte(p1, formater(ref, format, modele));
      changerTexte(p2, formater(ref * 2 - Math.round(ref * remise / 100), format, modele));
      changerTexte(p2b, formater(ref * 2, format, modele));
      changerTexte(racine.querySelector('[data-lp-prix]'), formater(ref, format, modele));

      var indispo = actives.some(function (e) { return e.variante && !e.variante.dispo; });
      if (dispo) dispo.hidden = !indispo;
      if (idRepli && actives[0].variante) idRepli.value = actives[0].variante.id;
    }

    pieces.forEach(function (piece, i) {
      // La 2e pièce part sur un autre coloris : on suggère d'en essayer deux.
      if (i === 1 && iC >= 0) {
        var cs = piece.querySelectorAll('[data-lp-couleur]');
        if (cs.length > 1) { cs[0].checked = false; cs[1].checked = true; }
      }
      majTailles(piece);
      piece.addEventListener('change', function (ev) {
        if (ev.target.matches('[data-lp-couleur]')) {
          majTailles(piece);
          if (true) {
            // Toute paire : la photo suit le dernier coloris choisi. Direction A : la photo studio (legging noir) sert de vue du premier coloris.
            var edito = racine.querySelector('[data-media-id="edito"]');
            var premier = racine.querySelector('[data-lp-piece="1"] [data-lp-couleur]');
            var cible = edito && premier && ev.target.value === premier.value ? 'edito' : premiereDeCouleur(ev.target.value).media;
            if (!cible) {
              // Coloris sans photo : jamais la photo d'un autre coloris, un panneau neutre à sa teinte.
              var pastille = ev.target.closest('.lp-pastille');
              var teinte = pastille && pastille.querySelector('.lp-pastille__teinte');
              var bloc = racine.querySelector('[data-lp-vide-teinte]');
              var nom = racine.querySelector('[data-lp-vide-nom]');
              if (bloc) bloc.style.background = teinte ? teinte.style.background : '';
              if (nom) nom.textContent = ev.target.value;
              cible = 'vide';
            }
            montrerMedia(cible);
          }
        }
        if (ev.target.matches('[data-lp-taille]')) {
          var f = piece.querySelector('[data-lp-choix-taille]');
          if (f) { f.classList.remove('is-erreur'); f.querySelector('[data-lp-erreur-taille]').hidden = true; }
        }
        maj();
      });
    });
    radiosQte.forEach(function (r) { r.addEventListener('change', maj); });

    racine.querySelectorAll('[data-lp-vignette]').forEach(function (b) {
      b.addEventListener('click', function () { montrerMedia(b.dataset.lpVignette); });
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var q = quantite();
      var actives = pieces.slice(0, q);
      var manquante = null;
      var lignes = {};
      actives.forEach(function (piece) {
        var e = etatPiece(piece);
        if (!e.variante) {
          var f = piece.querySelector('[data-lp-choix-taille]');
          if (f) {
            f.classList.add('is-erreur');
            f.querySelector('[data-lp-erreur-taille]').hidden = false;
            secouer(f.querySelector('.lp-tailles'));
          }
          if (!manquante) manquante = piece;
          return;
        }
        lignes[e.variante.id] = (lignes[e.variante.id] || 0) + 1;
      });
      if (manquante) {
        manquante.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var chemin = Object.keys(lignes).map(function (id) { return id + ':' + lignes[id]; }).join(',');
      bouton.disabled = true;
      bouton.setAttribute('aria-busy', 'true');
      // locale=en : la langue principale de la boutique est le français ; sans ce paramètre,
      // le paiement s'ouvrait en français pour les clientes US et CA (constaté le 21/10).
      window.location.href = '/cart/' + chemin + '?locale=en';
    });

    // Retour arrière depuis le paiement : le bouton redevient actif.
    window.addEventListener('pageshow', function () { bouton.disabled = false; bouton.removeAttribute('aria-busy'); });

    maj();

    // Barre d'achat mobile : visible quand le bouton principal est hors écran.
    var barre = document.querySelector('[data-lp-barre]');
    if (barre && 'IntersectionObserver' in window) {
      barre.hidden = false;
      var obs = new IntersectionObserver(function (entrees) {
        var e = entrees[0];
        var sous = e.boundingClientRect.top < 0;
        barre.classList.toggle('is-on', !e.isIntersecting && sous);
      });
      obs.observe(racine);
    }
  }

  function initEntete() {
    var h = document.querySelector('[data-lp-entete]');
    if (!h) return;
    var maj = function () { h.classList.toggle('is-plein', window.scrollY > 40); };
    window.addEventListener('scroll', maj, { passive: true });
    maj();
  }

  // taste-skill, étape 9 : dans chaque section, le titre, puis le texte, puis l'image,
  // décalés de 80 ms (jeton transitions.dev « micro », large stagger), une seule fois.
  // Jamais sur le bloc d'achat ; rien ne reste caché si l'observateur ne se déclenche pas.
  function initApparitions() {
    if (!('IntersectionObserver' in window)) return;
    var sections = [
      { racine: '.lp-points', texte: ['.lp-h2', '.lp-point'], image: ['.lp-points__img'] },
      { racine: '.lp-final', texte: ['.lp-h2', '.lp-texte', '.lp-btn'], image: ['.lp-final__img'] },
      { racine: '.lp-guide', texte: ['.lp-h2', '.lp-texte'], image: ['.lp-table__cadre'] },
      { racine: '.lp-faq', texte: ['.lp-h2', '.lp-faq__item'], image: [] },
      { racine: '.lp-contact', texte: ['.lp-h2', '.lp-texte', '.lp-champ', '.lp-btn'], image: [] },
      { racine: '.lp-pied', texte: ['.lp-pied__grille > div', '.lp-pied__nom'], image: [] }
    ];
    var pas = jeton('--duration-micro', 80);
    var cibles = [];
    sections.forEach(function (def) {
      document.querySelectorAll(def.racine).forEach(function (sec) {
        var rang = 0;
        function marquer(sel, texte) {
          sec.querySelectorAll(sel).forEach(function (el) {
            if (el.closest('[data-lp-achat]') || el.classList.contains('lp-reveal')) return;
            el.style.setProperty('--lp-delai', Math.min(rang, 5) * pas + 'ms');
            el.classList.add('lp-reveal');
            if (texte) el.classList.add('lp-reveal--texte');
            cibles.push(el);
            rang++;
          });
        }
        def.texte.forEach(function (sel) { marquer(sel, true); });
        def.image.forEach(function (sel) { marquer(sel, false); });
      });
    });
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-vu'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    cibles.forEach(function (el) { obs.observe(el); });
    setTimeout(function () {
      cibles.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-vu');
      });
    }, 2500);
  }

  // transitions.dev, « accordion expand » : grille 0fr ↔ 1fr, chevron retourné.
  // L'attribut `open` du <details> est posé avant l'ouverture et retiré après la fermeture.
  function initQuestions() {
    document.querySelectorAll('[data-lp-question]').forEach(function (d) {
      var s = d.querySelector('summary');
      d.setAttribute('data-open', d.open ? 'true' : 'false');
      s.addEventListener('click', function (ev) {
        ev.preventDefault();
        clearTimeout(d._minuteur);
        if (d.getAttribute('data-open') === 'true') {
          d.setAttribute('data-open', 'false');
          d._minuteur = setTimeout(function () { d.open = false; }, jeton('--acc-collapse', 250));
        } else {
          d.open = true;
          void d.offsetHeight;
          d.setAttribute('data-open', 'true');
        }
      });
    });
  }

  // transitions.dev, « modal open / close » appliqué au <dialog> du guide des tailles.
  function initGuide() {
    var dlg = document.querySelector('[data-lp-guide]');
    if (!dlg) document.querySelectorAll('[data-lp-ouvrir-guide]').forEach(function (b) { b.hidden = true; });
    function ouvrir() {
      if (!dlg || !dlg.showModal) { location.hash = 'guide-des-tailles'; return; }
      clearTimeout(dlg._minuteur);
      dlg.classList.remove('is-closing');
      if (!dlg.open) dlg.showModal();
      requestAnimationFrame(function () { dlg.classList.add('is-open'); });
    }
    function fermer() {
      if (!dlg.open) return;
      dlg.classList.remove('is-open');
      dlg.classList.add('is-closing');
      dlg._minuteur = setTimeout(function () { dlg.classList.remove('is-closing'); dlg.close(); }, jeton('--modal-close-dur', 150));
    }
    document.querySelectorAll('[data-lp-ouvrir-guide]').forEach(function (b) { b.addEventListener('click', ouvrir); });
    if (dlg) {
      dlg.querySelectorAll('[data-lp-fermer-guide]').forEach(function (b) { b.addEventListener('click', fermer); });
      dlg.addEventListener('click', function (ev) { if (ev.target === dlg) fermer(); });
      dlg.addEventListener('cancel', function (ev) { ev.preventDefault(); fermer(); });
    }
  }

  // Vidéos clientes : lecture muette seulement à l'écran, pause dès la sortie.
  // Rien ne démarre si l'utilisateur demande moins d'animations.
  function initVideos() {
    var videos = document.querySelectorAll('[data-lp-video]');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.5 });
    videos.forEach(function (v) { v.muted = true; obs.observe(v); });
  }

  // Zoom au défilement des atouts : l'atout le plus proche de la ligne de lecture pilote
  // le cadrage de la photo épinglée (photo, point visé en %, grossissement). Le cadrage est
  // calculé en px et borné pour ne jamais découvrir un bord de la photo.
  function initZoom(sec) {
    var cadre = sec.querySelector('.lp-zoom');
    var points = Array.prototype.slice.call(sec.querySelectorAll('[data-etape]'));
    var num = sec.querySelector('[data-lp-zoom-num]');
    if (!cadre || !points.length) return;
    var actif = null;
    var attente = false;

    function borner(v, min, max) { return Math.min(max, Math.max(min, v)); }

    function cadrer(li) {
      var st = getComputedStyle(li);
      var zx = parseFloat(st.getPropertyValue('--zx')) / 100 || 0.5;
      var zy = parseFloat(st.getPropertyValue('--zy')) / 100 || 0.5;
      var s = parseFloat(st.getPropertyValue('--ze')) || 1;
      var photo = li.getAttribute('data-photo') || '1';
      var fw = cadre.clientWidth, fh = cadre.clientHeight;
      cadre.setAttribute('data-photo', photo);
      cadre.querySelectorAll('.lp-zoom__img').forEach(function (img) {
        var ratio = (img.naturalWidth && img.naturalHeight) ? img.naturalWidth / img.naturalHeight : 16 / 9;
        var iw = fh * ratio * s, ih = fh * s;
        var estCible = img.classList.contains('lp-zoom__img--' + photo);
        // Cible au centre du cadre, sans bord découvert.
        var g = estCible ? fw / 2 - zx * iw : (fw - iw) / 2;
        var h = estCible ? fh / 2 - zy * ih : 0;
        g = borner(g, Math.min(0, fw - iw), 0);
        h = borner(h, fh - ih, 0);
        img.style.transform = 'translate(' + (g - fw / 2) + 'px,' + h + 'px) scale(' + s + ')';
      });
      if (num) num.textContent = li.getAttribute('data-etape');
    }

    function choisir() {
      attente = false;
      var mobile = window.innerWidth < 990;
      // Sur téléphone : milieu de l'espace libre entre la photo épinglée et la barre d'achat.
      var ligne = mobile ? (cadre.getBoundingClientRect().bottom + window.innerHeight - 90) / 2 : window.innerHeight / 2;
      var meilleur = null, ecart = Infinity;
      points.forEach(function (li) {
        var r = li.getBoundingClientRect();
        var d = Math.abs((r.top + r.bottom) / 2 - ligne);
        if (d < ecart) { ecart = d; meilleur = li; }
      });
      if (meilleur && meilleur !== actif) {
        if (actif) actif.classList.remove('is-actif');
        actif = meilleur;
        actif.classList.add('is-actif');
        cadrer(actif);
      }
    }

    function demander() { if (!attente) { attente = true; requestAnimationFrame(choisir); } }

    sec.classList.add('is-pilote');
    window.addEventListener('scroll', demander, { passive: true });
    window.addEventListener('resize', function () { if (actif) cadrer(actif); });
    cadre.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', function () { if (actif) cadrer(actif); });
    });
    choisir();
  }

  function init() {
    initEntete();
    initApparitions();
    document.querySelectorAll('[data-lp-achat]').forEach(initAchat);

    document.querySelectorAll('[data-lp-vers-achat]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var cible = document.getElementById((a.getAttribute('href') || '').slice(1)) || document.getElementById('achat');
        if (!cible) return;
        ev.preventDefault();
        cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    initQuestions();
    initGuide();
    initVideos();
    document.querySelectorAll('[data-lp-zoom]').forEach(initZoom);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
